<div id="refresh_system_data" (click)="loadIntegrations()"></div>
<div class="Bold_panel_header header-title">Configure your relevant integrations</div>
<div
  [formGroup]="SettingForm"
  class="space-one"
  fxLayout="column"
  [ngClass]="class == true ? 'height-536' : 'height-535'"
>
  <div class="height-524">
    <mat-accordion class="faqs-accordion icon-size">
      @if (
        currentUser.PRODUCTTYPE == 'Solicitor' &&
        ('Searching' | tierPermission: 'Searching') &&
        ('Searching' | tierPermission: 'Searching').ALLOWED == 1
      ) {
        <mat-expansion-panel label="InfoTrack" mat-align-tabs="start" fxLayout="column">
          <mat-expansion-panel-header class="Bold_panel_header">
            <mat-panel-title>
              <mat-icon>
                <img src="assets/icons/web_app/infotrack.ico" />
              </mat-icon>
              &nbsp; InfoTrack
            </mat-panel-title>
          </mat-expansion-panel-header>
          <div class="border-line"></div>
          <br />
          <div class="one" [formGroup]="SettingForm" fxLayout="column">
            <div fxLayout="row wrap" fxLayoutAlign="start center" fxFlex="1 0 auto">
              <mat-form-field
                appearance="outline"
                class="searchs-imput pr-1"
                [ngClass]="{
                  'has-error': $safeNavigationMigration(errorWarningData.Error?.SEARCHPROVIDER),
                  'has-warning': $safeNavigationMigration(errorWarningData.Warning?.SEARCHPROVIDER),
                }"
              >
                <mat-label>Provider</mat-label>
                <mat-select name="SEARCHPROVIDER" formControlName="SEARCHPROVIDER">
                  @for (sp of searchProvider; track sp) {
                    <mat-option value="{{ sp.DESCRIPTION }}">
                      {{ sp.DESCRIPTION }}
                    </mat-option>
                  }
                </mat-select>
              </mat-form-field>
              <mat-form-field
                appearance="outline"
                class="searchs-imput pr-1"
                [ngClass]="{
                  'has-error': $safeNavigationMigration(errorWarningData.Error?.SEARCHPROVIDER),
                  'has-warning': $safeNavigationMigration(errorWarningData.Warning?.SEARCHPROVIDER),
                }"
              >
                <mat-label>Document Download User</mat-label>
                <mat-select name="SEARCHDOWNLOADUSERGUID" formControlName="SEARCHDOWNLOADUSERGUID">
                  @for (user of UserList; track user) {
                    <mat-option value="{{ user.USERGUID }}">
                      {{ user.USERNAME }}
                    </mat-option>
                  }
                </mat-select>
              </mat-form-field>
              <mat-form-field
                appearance="outline"
                class="searchs-imput pr-1"
                [ngClass]="{
                  'has-error': $safeNavigationMigration(errorWarningData.Error?.SEARCHGSTHANDLING),
                  'has-warning': $safeNavigationMigration(
                    errorWarningData.Warning?.SEARCHGSTHANDLING
                  ),
                }"
              >
                <mat-label>GST Handling</mat-label>
                <mat-select name="SEARCHGSTHANDLING" formControlName="SEARCHGSTHANDLING">
                  @for (gh of searchGstHanal; track gh) {
                    <mat-option value="{{ gh.DESCRIPTION }}">
                      {{ gh.DESCRIPTION }}
                    </mat-option>
                  }
                </mat-select>
              </mat-form-field>
            </div>
            <div class="mt-4" fxLayout="row wrap" fxLayoutAlign="start center" fxFlex="1 0 auto">
              <mat-form-field
                appearance="outline"
                class="searchs-imput pr-1"
                [ngClass]="{
                  'has-error': $safeNavigationMigration(errorWarningData.Error?.SEARCHUSERNAME),
                  'has-warning': $safeNavigationMigration(errorWarningData.Warning?.SEARCHUSERNAME),
                }"
              >
                <mat-label>Username</mat-label>
                <input class="sideText userpass" matInput formControlName="SEARCHUSERNAME" />
              </mat-form-field>
              <mat-form-field
                appearance="outline"
                class="searchs-imput pr-1"
                [ngClass]="{
                  'has-error': $safeNavigationMigration(errorWarningData.Error?.SEARCHPASSWORD),
                  'has-warning': $safeNavigationMigration(errorWarningData.Warning?.SEARCHPASSWORD),
                }"
              >
                <mat-label>Password</mat-label>
                <input
                  class="sideText userpass"
                  matInput
                  [type]="hide ? 'password' : 'text'"
                  formControlName="SEARCHPASSWORD"
                />
                <mat-icon matSuffix (click)="hide = !hide">
                  {{ hide ? 'visibility_off' : 'visibility' }}
                </mat-icon>
              </mat-form-field>
              <mat-form-field
                appearance="outline"
                class="searchs-imput pr-1"
                [ngClass]="{
                  'has-error': $safeNavigationMigration(errorWarningData.Error?.SEARCHURL),
                  'has-warning': $safeNavigationMigration(errorWarningData.Warning?.SEARCHURL),
                }"
              >
                <mat-label>Alternate Search URL</mat-label>
                <input class="sideText" matInput formControlName="SEARCHURL" />
              </mat-form-field>
            </div>
            <!-- <div fxLayout="row wrap" fxLayoutAlign="start center" fxFlex="1 0 auto">
          </div> -->
          </div>
          <div>
            <mat-dialog-actions class="popup_ftr justify-end!">
              <button
                class="mainbtn_size"
                matButton="filled"
                [disabled]="isspinerInfo"
                (click)="saveInfoTrack()"
              >
                @if (isspinerInfo) {
                  <mat-spinner diameter="24"></mat-spinner>
                }
                Save
              </button>
              <!-- <button class="btn_2" mat-raised-button color="primary" cdkFocusInitial>Don't Save</button> -->
            </mat-dialog-actions>
          </div>
        </mat-expansion-panel>
      }
      @if (
        ('Xero Integration' | tierPermission: 'Xero Integration') &&
        ('Xero Integration' | tierPermission: 'Xero Integration').ALLOWED == 1
      ) {
        <mat-expansion-panel label="Xero Integration" mat-align-tabs="start" fxLayout="column">
          <mat-expansion-panel-header class="Bold_panel_header">
            <mat-panel-title>
              <mat-icon>
                <img src="assets/icons/web_app/xero.ico" />
              </mat-icon>
              &nbsp; Xero
            </mat-panel-title>
          </mat-expansion-panel-header>
          <div class="border-line"></div>
          <app-xero-integration
            [errorWarningData]="errorWarningData"
            [SettingForm]="SettingForm"
          ></app-xero-integration>
        </mat-expansion-panel>
      }

      <mat-expansion-panel label="SilqPay" mat-align-tabs="start" fxLayout="column">
        <mat-expansion-panel-header class="Bold_panel_header">
          <mat-panel-title>
            <mat-icon>
              <img src="assets/icons/web_app/silqpay.ico" />
            </mat-icon>
            &nbsp; SilqPay
          </mat-panel-title>
        </mat-expansion-panel-header>
        <div class="border-line"></div>
        <app-silqpay
          [errorWarningData]="errorWarningData"
          [silqPayDrop]="silqPayDrop"
          [SettingForm]="SettingForm"
        ></app-silqpay>
      </mat-expansion-panel>

      <mat-expansion-panel label="Email Configuration" mat-align-tabs="start" fxLayout="column">
        <mat-expansion-panel-header class="Bold_panel_header">
          <mat-panel-title>
            <mat-icon>
              <img src="assets/icons/web_app/Email.ico" />
            </mat-icon>
            &nbsp; Email Configuration
          </mat-panel-title>
        </mat-expansion-panel-header>
        <div class="border-line"></div>
        <app-email-configuration
          [SettingForm]="SettingForm"
          [emilSystem]="emilSystem"
          [emailSaveStrategy]="emailSaveStrategy"
          [emailSystemType]="emailSystemType"
        ></app-email-configuration>
      </mat-expansion-panel>
      <mat-expansion-panel label="AML/CTF settings" mat-align-tabs="start" fxLayout="column">
        <mat-expansion-panel-header class="Bold_panel_header">
          <mat-panel-title>
            <mat-icon>
              <!-- <img src="assets/icons/web_app/Email.ico"> -->
              @if (currentUser?.THEMECOLOUR == 'theme-yellow-light') {
                <img src="assets/icons/web_app/KYC checks 1.svg" />
              }
              @if (currentUser?.THEMECOLOUR == 'theme-default') {
                <img src="assets/icons/web_app/KYC checks 1.svg" />
              }
              @if (currentUser?.THEMECOLOUR == 'theme-blue-gray-dark') {
                <img src="assets/icons/web_app/KYC checks 2.svg" />
              }
              @if (currentUser?.THEMECOLOUR == 'theme-pink-dark') {
                <img src="assets/icons/web_app/KYC checks 2.svg" />
              }
            </mat-icon>
            &nbsp; AML/CTF Configuration
          </mat-panel-title>
        </mat-expansion-panel-header>
        <div class="border-line"></div>
        <app-aml-ctf-setting
          [SettingForm]="SettingForm"
          [errorWarningData]="errorWarningData"
        ></app-aml-ctf-setting>
      </mat-expansion-panel>
    </mat-accordion>
  </div>
</div>
<div align="end">
  <mat-dialog-actions class="popup_ftr">
    <button
      class="mainbtn_size"
      matButton="filled"
      [disabled]="isspiner"
      (click)="saveIntegrations()"
    >
      @if (isspiner) {
        <mat-spinner diameter="24"></mat-spinner>
      }
      Save
    </button>
    <!-- <button class="btn_2" mat-raised-button color="primary" cdkFocusInitial>Don't Save</button> -->
  </mat-dialog-actions>
</div>
